module.exports = __webpack_public_path__ + "img/activities-5.ea3baa3c.jpg";